import type { ReactNode } from "react";
import { cn } from "./utils/cn";

type Variant = "info" | "success" | "warning" | "danger";

export function Banner({
  variant = "info",
  title,
  message,
  action,
  onClose,
  className,
}: {
  variant?: Variant;
  title?: string;
  message?: ReactNode;
  action?: ReactNode;
  onClose?: () => void;
  className?: string;
}) {
  const tone =
    variant === "success"
      ? { bg: "bg-success/10", pill: "bg-success" }
      : variant === "warning"
        ? { bg: "bg-warning/10", pill: "bg-warning" }
        : variant === "danger"
          ? { bg: "bg-danger/10", pill: "bg-danger" }
          : { bg: "bg-ring/10", pill: "bg-ring" };
  return (
    <div
      className={cn("flex items-start gap-3 rounded-md border p-3", tone.bg, className)}
      role="status"
    >
      <span className={cn("mt-1 inline-block h-2 w-2 rounded-full", tone.pill)} />
      <div className="flex-1">
        {title && <div className="text-sm font-semibold text-text">{title}</div>}
        {message && <div className="text-sm text-text/80">{message}</div>}
      </div>
      {action}
      {onClose && (
        <button
          type="button"
          className="ml-2 rounded p-1 text-muted hover:bg-muted/10"
          aria-label="Fermer la notification"
          onClick={onClose}
        >
          ×
        </button>
      )}
    </div>
  );
}
